import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { WebBrowserTabBlinkerService } from './web-browser-tab-blinker-service';

@Injectable({
    providedIn: 'root',
})
export class SessionTimeoutService {
    /**
     * Nombre d'extension de la session.
     */
    private sessionExtensionCounter = 0;

    /**
     * Souscription aux evenments du minuteur.
     */
    private timerSubscription: Subscription;

    /**
     * Instance du minuteur.
     */
    private timer: Observable<number>;

    /**
     * Emis lorsque le minuteur arrive à échéance.
     */
    public timeoutExpired: Subject<number> = new Subject<number>();

    /**
     * Delai (en secondes) avant l'expiration pour afficher la notification à l'utilisateur.
     */
    public notificationDelay: number = 60;

    /**
     * Constructeur.
     */
    constructor(private webBrowserTabBlinkerService: WebBrowserTabBlinkerService) {
        this.timeoutExpired.subscribe((x) => {
            console.log("Nombre d'extension de la session : " + x.toString());
        });
    }

    /**
     * Souscrit aux événements du minuteur.
     */
    private setSubscription() {
        this.timerSubscription = this.timer.subscribe((x) => {
            this.timerComplete();
        });
    }

    /**
     * Declenche le minuteur d'expiration de session.
     * @param sessionTimeoutDate : Date d'expiration de la session
     */
    public startTimer(sessionTimeoutDate: Date) {
        console.log(`Initialise l'expiration de la session à ${sessionTimeoutDate}`);

        if (this.timerSubscription) {
            this.stopTimer();
        }
        var remainingSessionTime = this.calculateRemainingSessionTime(sessionTimeoutDate);

        console.log(`Délai avant expiration : ${remainingSessionTime} ms`);

        this.timer = timer(remainingSessionTime);
        this.setSubscription();
        this.webBrowserTabBlinkerService.stop();
    }

    /**
     * Stoppe le minuteur d'expiration de session.
     */
    public stopTimer() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
            this.timerSubscription = null;
        }
    }

    /**
     * Réinitialise le minuteur d'expiration de session.
     * @param sessionTimeoutDate : Date d'expiration de la session
     */
    public resetTimer(sessionTimeoutDate: Date) {
        console.log('Reset du timer à ', sessionTimeoutDate);
        this.startTimer(sessionTimeoutDate);
        this.webBrowserTabBlinkerService.stop();
    }
    public calculateRemainingSessionTime(sessionTimeoutDate: Date) {
        return sessionTimeoutDate.getTime() - new Date().getTime() - this.notificationDelay * 1000;
    }

    /**
     * Appellée lorsque le minuteur arrive à échéance.
     */
    private timerComplete() {
        this.timeoutExpired.next(++this.sessionExtensionCounter);
        this.webBrowserTabBlinkerService.start();
    }
}
